/* My Organic Formula — Help Center behaviours
   Scoped to .mof-hc. Search, TOC, grid/list toggle, quiz redirect. */
(function () {
  "use strict";

  var QUIZ_URL = "https://www.myorganicformula.com/pages/quiz-quiz-1a-formula-finder";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---------- Search ---------- */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function wireSearch(container) {
    var input = container.querySelector('input[type="search"], input');
    var results = container.querySelector(".search__results");
    if (!input || !results) return;
    var index = window.__HC_INDEX__ || [];

    function render(q) {
      q = (q || "").trim().toLowerCase();
      if (q.length < 2) { results.hidden = true; results.innerHTML = ""; return; }
      var hits = index.filter(function (a) {
        return (a.t + " " + a.c).toLowerCase().indexOf(q) !== -1;
      }).slice(0, 8);
      if (!hits.length) {
        results.innerHTML = '<div class="search__none">No results found</div>';
      } else {
        results.innerHTML = hits.map(function (a) {
          return '<a href="' + a.u + '">' + escapeHtml(a.t) +
                 '<span class="cat">' + escapeHtml(a.c) + "</span></a>";
        }).join("");
      }
      results.hidden = false;
    }

    input.addEventListener("input", function () { render(input.value); });
    input.addEventListener("focus", function () { if (input.value.trim().length >= 2) render(input.value); });
    document.addEventListener("click", function (e) {
      if (!container.contains(e.target)) { results.hidden = true; }
    });
  }

  /* ---------- Grid / list toggle ---------- */
  function wireToggle(group) {
    var btns = group.querySelectorAll("button");
    if (btns.length < 2) return;
    // target = next .cats or .art-list sibling in the same view
    var view = group.closest(".wrap, .cat-wrap") || document;
    var target = view.querySelector(".cats, .art-list");
    if (!target) return;
    var gridBtn = btns[0], listBtn = btns[1];
    gridBtn.addEventListener("click", function () {
      target.classList.remove("is-list");
      gridBtn.setAttribute("aria-pressed", "true");
      listBtn.setAttribute("aria-pressed", "false");
    });
    listBtn.addEventListener("click", function () {
      target.classList.add("is-list");
      listBtn.setAttribute("aria-pressed", "true");
      gridBtn.setAttribute("aria-pressed", "false");
    });
  }

  /* ---------- Table of contents ---------- */
  function buildToc() {
    var toc = document.getElementById("artToc");
    var body = document.querySelector(".mof-hc .art-body");
    if (!toc || !body) return;
    var heads = body.querySelectorAll("h2[id], h3[id]");
    if (heads.length < 2) { toc.style.display = "none"; return; }

    var nav = document.createElement("nav");
    heads.forEach(function (h) {
      var a = document.createElement("a");
      a.href = "#" + h.id;
      a.textContent = h.textContent;
      if (h.tagName === "H3") a.className = "lvl-3";
      a.addEventListener("click", function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: "smooth", block: "start" });
        history.replaceState(null, "", "#" + h.id);
      });
      nav.appendChild(a);
    });
    toc.innerHTML =
      '<div class="art-toc__head">On this page<button class="toc-close" aria-label="Close">&times;</button></div>';
    toc.appendChild(nav);

    // scroll spy
    var links = nav.querySelectorAll("a");
    function spy() {
      var top = window.scrollY + 90;
      var current = heads[0];
      heads.forEach(function (h) { if (h.offsetTop <= top) current = h; });
      links.forEach(function (l) {
        l.classList.toggle("is-active", l.getAttribute("href") === "#" + current.id);
      });
    }
    window.addEventListener("scroll", spy, { passive: true });
    spy();

    // mobile toggle
    var toggle = document.querySelector(".toc-toggle");
    var closeBtn = toc.querySelector(".toc-close");
    if (toggle) {
      toggle.addEventListener("click", function () {
        toc.classList.toggle("is-open");
        toc.scrollIntoView({ behavior: "smooth", block: "nearest" });
      });
    }
    if (closeBtn) closeBtn.addEventListener("click", function () { toc.classList.remove("is-open"); });
  }

  /* ---------- Quiz links → open the theme's VQB popup ---------- */
  function wireQuiz() {
    // In-article CTAs are baked as href="#quiz"; the comparison chart CTA is a.cta-btn.
    // Give each the fallback quiz-page href plus the theme's data-quiz-popup trigger,
    // so a click opens the Formula Finder popup (handled globally by snippets/quiz-popup.liquid).
    var sel = '.mof-hc a[href="#quiz"], .mof-hc a[href$="#quiz"], a.cta-btn[href*="quiz-quiz-1a-formula-finder"]';
    document.querySelectorAll(sel).forEach(function (a) {
      a.setAttribute("href", QUIZ_URL);
      a.setAttribute("data-quiz-popup", "");
    });
  }

  /* ---------- Gorgias chat buttons ---------- */
  function wireGorgias() {
    document.querySelectorAll(".mof-hc [data-gorgias-msg]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var msg = btn.getAttribute("data-gorgias-msg");
        function go() {
          try {
            window.GorgiasChat.open();
            if (msg) window.GorgiasChat.setCurrentInput(msg);
          } catch (err) {}
        }
        if (window.GorgiasChat && window.GorgiasChat.open) {
          go();
        } else {
          window.addEventListener("gorgias-widget-loaded", go, { once: true });
        }
      });
    });
  }

  ready(function () {
    document.querySelectorAll(".mof-hc .search, .mof-hc .cat-search").forEach(wireSearch);
    document.querySelectorAll(".mof-hc .view-toggle").forEach(wireToggle);
    buildToc();
    wireQuiz();
    wireGorgias();
  });
})();
